export const PERMISSION_FLAGS = ['read', 'write', 'patientBooker'] as const;

export type PermissionFlag = (typeof PERMISSION_FLAGS)[number];

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+\.[^\s@]+$/;
